import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { theme } from '~/styles/theme';
import { Icon } from '~/components';
import * as S from './styles';

export default function ClubStats({
  title,
  local,
  columns,
  data,
  className,
  fixedColumn,
  fixedHeader,
}) {
  const { loading } = useSelector(state => state.matches.directStats);

  const getTableData = () => {
    if (local) {
      return data.homeTeamStats ? data.homeTeamStats.playerStats : [];
    }
    return data.awayTeamStats ? data.awayTeamStats.playerStats : [];
  };

  const processPlayerStats = player => {
    const playerStatKeys = Object.keys(player);
    let resultantPlayer = { ...player };
    playerStatKeys.forEach(stat => {
      if (
        player[stat] &&
        stat[0] !== '@' &&
        typeof resultantPlayer[stat] === 'object'
      ) {
        resultantPlayer = {
          ...resultantPlayer,
          [stat]: (
            <>
              {player[stat].isTop && (
                <Icon name="star" size={8} color="yellow" />
              )}
              {player[stat].value}
            </>
          ),
        };
      }
    });
    return resultantPlayer;
  };

  const rowsThatHaveTopCss = () => {
    let resultantRowCss = '';
    getTableData().forEach((player, index) => {
      const playerKeys = Object.keys(player);
      playerKeys.forEach(key => {
        if (
          player[key] &&
          typeof player[key] === 'object' &&
          player[key].isTop
        ) {
          resultantRowCss += `
            &:nth-child(${index + 1}){
              td {
                border-top: solid 1px ${theme.yellow};
                border-bottom: solid 1px ${theme.yellow};
                &:first-child {
                  border-left: solid 1px ${theme.yellow};
                }
                &:last-child {
                  border-right: solid 1px ${theme.yellow};
                }
              }}
          `;
        }
      });
    });
    return resultantRowCss;
  };

  return (
    <S.Container className={className}>
      <S.Header isLocal={local}>
        <S.Title>{title}</S.Title>
      </S.Header>
      <S.StatsTable
        isFetching={loading && getTableData().length < 1}
        placeholderNumElements={11}
        placeholderNumColumns={16}
        columns={columns}
        isLocal={local}
        fixedColumn={fixedColumn}
        fixedHeader={fixedHeader}
        rowsThatHaveTop={rowsThatHaveTopCss()}
        data={getTableData().map(player => {
          return {
            ...processPlayerStats(player),
            playerName: (
              <S.PlayerName>
                <S.Bold>{player.shirtNumber}</S.Bold>
                {player.playerName}
              </S.PlayerName>
            ),
          };
        })}
        styleOptions={{
          backgroundColor: local ? theme.white : theme.dark4,
          primaryColor: local ? theme.white : theme.dark4MidOpacity,
          secondaryColor: local ? theme.light2 : theme.dark5,
          textColor: local ? theme.dark : theme.white,
          textHeaderColor: local ? theme.dark : theme.white,
          fullWidth: true,
        }}
      />
      <S.TableLegendFooter
        isLocal={local}
        data={data ? data.statsTableHeadersAndDescription : null}
      />
    </S.Container>
  );
}

ClubStats.propTypes = {
  title: PropTypes.string,
  local: PropTypes.bool,
  columns: PropTypes.array,
  data: PropTypes.object,
  className: PropTypes.string,
  fixedColumn: PropTypes.bool,
  fixedHeader: PropTypes.bool,
};

ClubStats.defaultProps = {
  title: null,
  local: null,
  columns: [],
  data: {},
  className: null,
  fixedColumn: false,
  fixedHeader: false,
};
